export enum ChallengeType {
  Challenge = 'Challenges',
  SubChallenge = 'Sub-Challenges',
}

export enum ChallengeName {
  Challenge = 'Challenge Name',
  SubChallenge = 'Sub-Challenge Name',
}
